import { authenticatedFetch } from './base'

/**
 * Search for units of measurement
 *
 * @param {string} searchPhrase - search term 
 * @returns {*} - response containing a list of units of measurement
 */
export const search = (searchPhrase) => {
	var url = `/api/units`

	if (searchPhrase && searchPhrase.length > 0) {
		url = `${url}?searchPhrase=${encodeURIComponent(searchPhrase)}`
	}

	return authenticatedFetch(url, { method: 'GET' })
		.then(function(response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function(patient) {
			return patient
		})
}
